<template>
  <div class="notification-wrapper" :class="[{ show: showModal }]" @click.self="closeModal">
  <div class="notification">
    <div class="close-notify" @click="closeModal">
      <i class="fa fa-times"></i>
    </div>
    <div class="notification-content">
      <div v-if="adDivisionError">
        <p class=modal-title>HOUSTON, WE HAVE A PROBLEM!</p>
        <div class="info-message error-message">
          <span>The product you're viewing is listed in a different location than your selected shipping area.</span>
          <span>This promotion is not available in your current area.</span>
        </div>
      </div>
      <div v-else>
        <p class="modal-title">SHOPPING UPDATE!</p>
        <div class="info-message">
          <span>The BigYellowBag product you added is from a different location than your selected shipping area.</span>
          <span>Pricing and discounts may vary by location. Your cart will be updated accordingly.</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  computed: {
    showModal() {
      return this.$store.state.adDivisionMismatch.showModal;
    },

    adDivisionError() {
      return this.$store.state.adDivisionMismatch.adDivisionError;
    },
  },

  methods: {
    closeModal() {
      this.$store.commit('setProperties', { adDivisionMismatch: { showModal: false, adDivisionError: false } });
    },
  },
};
</script>
<style scoped>
  .notification-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
  }

  .notification-wrapper.show {
    opacity: 1;
    visibility: visible;
  }

  .notification {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    width: 90%;
    max-width: 500px;
    position: relative;
    padding: 24px;
    min-height: 200px;
  }

  .close-notify {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    color: #666;
    transition: color 0.2s ease;
  }

  .close-notify:hover {
    color: #333;
  }

  .modal-title {
    text-transform: uppercase;
    justify-content: center;
    min-width: 100%;
  }

  .notification-content p {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0 0 16px 0;
  }

  .info-message {
    background-color: #FFF9C4;
    border-left: 3px solid #FFE500;
    margin: 0;
    padding: 16px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .info-message span {
    display: block;
    width: 100%;
    margin: 0;
  }

  .error-message {
    background-color: #FFF2F3;
    color: #DC2626;
    border-left: 3px solid #DC2626;
  }
</style>
